//Built-in libraries

//Third party libraries

import Button from '@/components/UI/Button';
import { HookCheckboxGroup } from '@/components/UI/HookForm/Form/CheckBoxGroup';
//Custom components
import { HookInput } from '@/components/UI/HookForm/Form/Input';
import HookMaskedInput from '@/components/UI/HookForm/Form/MaskedInput';
import { HookSelect } from '@/components/UI/HookForm/Form/Select';
//Services
import { useApplicationFormContext } from '@/features/ApplicationForm/ApplicationFormProvider';

//STP Libraries

import { useFormContext } from 'react-hook-form';
import type { InferType } from 'yup';
import type { RentalRegistryValidationSchema } from '@/features/ApplicationForm/FormConfig/RentalRegistry/ApplicationForm/validationSchema';
//Assets and Miscellaneous
import { States } from '../../../../../../constants';
import { anyApply } from './constant';

//Component Begin

export default function PropertyManagement() {
  const { setCurrentStep } = useApplicationFormContext();
  const formMethods = useFormContext<InferType<(typeof RentalRegistryValidationSchema)[3]>>();

  return (
    <div className='sm:rounded-r-md sm:overflow-hidden'>
      <div className='py-6 px-4 space-y-6 sm:p-6'>
        <h3 className='text-lg leading-6 font-medium text-green-500'>Property Management</h3>
        <div className='grid grid-cols-6 gap-6'>
          <HookInput
            formMethods={formMethods}
            customClassName='col-span-3'
            label='Entity Name'
            name='propertyManagement.entityName'
            type='text'
          />
          <HookInput
            formMethods={formMethods}
            customClassName='col-span-6 sm:col-span-3'
            label='Contact Person Full Name'
            name='propertyManagement.contactPersonName'
            type='text'
          />
          <HookInput
            formMethods={formMethods}
            customClassName='col-span-6 sm:col-span-3'
            label='Contact Person Email'
            name='propertyManagement.contactPersonEmail'
            type='email'
            placeholder='myemail@example.com'
          />
          <HookMaskedInput
            formMethods={formMethods}
            customClassName='col-span-6 sm:col-span-3'
            label='Phone Number'
            name='propertyManagement.phone'
            id='phone'
            maskedComponent='phone'
          />
          <HookInput
            formMethods={formMethods}
            customClassName='col-span-6'
            label='Street Address'
            name='propertyManagement.streetAddress'
            type='text'
          />
          <HookInput
            formMethods={formMethods}
            customClassName='col-span-6 sm:col-span-6 lg:col-span-2'
            label='City'
            name='propertyManagement.city'
            type='text'
          />
          <HookSelect
            formMethods={formMethods}
            customClassName='col-span-6 sm:col-span-3 lg:col-span-2'
            label='State / Province'
            name='propertyManagement.state'
            options={States.map((state) => ({
              label: state.name,
              value: state.name,
            }))}
          />

          <HookInput
            formMethods={formMethods}
            customClassName='col-span-6 sm:col-span-6 lg:col-span-2'
            label='ZIP / Postal code'
            name='propertyManagement.zipCode'
            type='number'
          />
          <HookInput
            formMethods={formMethods}
            customClassName='col-span-6 sm:col-span-6 lg:col-span-2'
            label='Website (if available)'
            name='propertyManagement.website'
            type='text'
            placeholder='mywebsite.com'
          />
          <HookInput
            formMethods={formMethods}
            customClassName='col-span-6 sm:col-span-6 lg:col-span-2'
            label='Formation Date'
            name='propertyManagement.formationDate'
            type='date'
          />
          <HookInput
            formMethods={formMethods}
            customClassName='col-span-6 sm:col-span-6 lg:col-span-2'
            label='Number of Full Time Employees'
            name='propertyManagement.fullTimeEmployeeCount'
            type='number'
          />
        </div>
        <div>
          <HookCheckboxGroup
            formMethods={formMethods}
            label='Check any of the following that apply:'
            name='propertyManagement.anyApply'
            id='any-apply'
            options={anyApply.map((p) => ({
              label: p.label,
              value: p.label,
            }))}
          />
        </div>
        <div className='flex gap-4 justify-end mt-5'>
          <Button label='Previous' btnStyle='neutral' type='button' onClick={() => setCurrentStep((prev) => prev - 1)} />
          <Button label='Next' btnStyle='primary' type='submit' />
        </div>
      </div>
    </div>
  );
}
